import React from 'react';
import { Box, Typography, Button, Container, ThemeProvider, CssBaseline } from '@mui/material';
import CheckCircleOutlineIcon from '@mui/icons-material/CheckCircleOutline';
import { Link } from 'react-router-dom';
import { theme } from '../theme/theme';

const PaymentSuccess: React.FC = () => {
  return (
    <ThemeProvider theme={theme}>
      <CssBaseline />
      <Container maxWidth="sm">
        <Box
          sx={{
            mt: 8,
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'center',
            p: 4,
            boxShadow: 3,
            borderRadius: 2,
            bgcolor: 'background.paper',
          }}
        >
          <CheckCircleOutlineIcon color="success" sx={{ fontSize: 80, mb: 2 }} />
          <Typography variant="h4" component="h1" gutterBottom sx={{ color: theme.palette.text.primary }}>
            ¡Pago Exitoso!
          </Typography>
          <Typography variant="body1" align="center" sx={{ mb: 3, color: theme.palette.text.secondary }}>
            Tu transacción se ha completado con éxito. ¡Gracias por tu compra!
          </Typography>
          <Button variant="contained" color="primary" component={Link} to="http://localhost:3000/profile">
            Ir al Portal
          </Button>
        </Box>
      </Container>
    </ThemeProvider>
  );
};

export default PaymentSuccess;
